<div class="demo-wrapper">

  <div class="demo-header">
    <mat-icon class="demo-icon">science</mat-icon>
    <div class="demo-header-text">
      <h2 class="demo-title">Demo -- Tipos de Acao</h2>
      <p class="demo-subtitle">Selecione linhas na tabela e teste cada tipo de acao. Use IDCONFs reais do seu ambiente.</p>
    </div>
    <span class="selection-badge" *ngIf="selected.length > 0">
      {{ selected.length }} linha(s) selecionada(s)
    </span>
  </div>

  <div class="config-row">

    <!-- FN -->
    <mat-card class="config-card config-fn">
      <mat-card-header>
        <div mat-card-avatar class="type-avatar fn"><mat-icon>functions</mat-icon></div>
        <mat-card-title>TYPE = 'FN'</mat-card-title>
        <mat-card-subtitle>Formula Nova -- FormulaServices/test com motorNovo=true</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Expressao</mat-label>
          <input matInput [(ngModel)]="configFN.expression" placeholder="ex: concatenar(PEDIDO, ' - ', CLIENTE)">
          <mat-hint>Vars disponiveis: PEDIDO, CLIENTE, MARKETPLACE, VALOR, STATUS, __rows</mat-hint>
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button color="primary" (click)="executarFN()" [disabled]="!selected.length || executingFN">
          <mat-icon>functions</mat-icon>&nbsp;{{ executingFN ? 'Executando...' : 'Executar Formula Nova' }}
        </button>
      </mat-card-actions>
    </mat-card>

    <!-- C -->
    <mat-card class="config-card config-c">
      <mat-card-header>
        <div mat-card-avatar class="type-avatar c"><mat-icon>settings_backup_restore</mat-icon></div>
        <mat-card-title>TYPE = 'C'</mat-card-title>
        <mat-card-subtitle>Fluxo Antigo -- JsonBrokerServices/action polling MKTPLGI (5s)</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="field-row">
          <mat-form-field appearance="outline">
            <mat-label>IDCONF</mat-label>
            <input matInput type="number" [(ngModel)]="configC.idConf" placeholder="ID do fluxo">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>CODECOMPANY</mat-label>
            <input matInput type="number" [(ngModel)]="configC.codecompany">
          </mat-form-field>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button color="accent" (click)="executarC()" [disabled]="!selected.length">
          <mat-icon>settings_backup_restore</mat-icon>&nbsp;Executar Fluxo Antigo
        </button>
      </mat-card-actions>
    </mat-card>

    <!-- NM -->
    <mat-card class="config-card config-nm">
      <mat-card-header>
        <div mat-card-avatar class="type-avatar nm"><mat-icon>rocket_launch</mat-icon></div>
        <mat-card-title>TYPE = 'NM'</mat-card-title>
        <mat-card-subtitle>Fluxo NEWMODE -- FlowServices/runOnlineAsync polling jobStatus (1.5s)</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="field-row">
          <mat-form-field appearance="outline">
            <mat-label>IDCONF</mat-label>
            <input matInput type="number" [(ngModel)]="configNM.idConf" placeholder="ID do fluxo NEWMODE">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>CODECOMPANY</mat-label>
            <input matInput type="number" [(ngModel)]="configNM.codecompany">
          </mat-form-field>
        </div>
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Contexto de Acao</mat-label>
          <input matInput [(ngModel)]="configNM.contextoAcao" placeholder="EXECUTAR">
          <mat-hint>__contextoAcao enviado no context do runOnlineAsync</mat-hint>
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button class="btn-nm" (click)="executarNM()" [disabled]="!selected.length">
          <mat-icon>rocket_launch</mat-icon>&nbsp;Executar Fluxo Novo
        </button>
      </mat-card-actions>
    </mat-card>

  </div>

  <!-- Tabela de dados mock -->
  <mat-card class="table-card">
    <mat-card-header>
      <mat-card-title>Pedidos de Demonstracao</mat-card-title>
      <mat-card-subtitle>Dados ficticios -- clique em qualquer linha ou use o checkbox para selecionar</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <table mat-table [dataSource]="dataSource" class="demo-table">

        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef style="width:52px">
            <mat-checkbox
              (change)="toggleAll()"
              [checked]="isAllSelected()"
              [indeterminate]="isSomeSelected()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="toggleRow(row)" [checked]="isSelected(row)"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="PEDIDO">
          <th mat-header-cell *matHeaderCellDef>Pedido</th>
          <td mat-cell *matCellDef="let row"><strong>{{row.PEDIDO}}</strong></td>
        </ng-container>

        <ng-container matColumnDef="CLIENTE">
          <th mat-header-cell *matHeaderCellDef>Cliente</th>
          <td mat-cell *matCellDef="let row">{{row.CLIENTE}}</td>
        </ng-container>

        <ng-container matColumnDef="MARKETPLACE">
          <th mat-header-cell *matHeaderCellDef>Marketplace</th>
          <td mat-cell *matCellDef="let row">
            <span class="marketplace-badge">{{row.MARKETPLACE}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="VALOR">
          <th mat-header-cell *matHeaderCellDef>Valor</th>
          <td mat-cell *matCellDef="let row">R$ {{row.VALOR | number:'1.2-2'}}</td>
        </ng-container>

        <ng-container matColumnDef="STATUS">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            <span class="status-badge" [ngClass]="'status-' + row.STATUS.toLowerCase()">{{row.STATUS}}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            [class.selected-row]="isSelected(row)"
            (click)="toggleRow(row)">
        </tr>

      </table>
    </mat-card-content>
  </mat-card>

</div>
